import "./index.sass";
import { useTranslation } from "@helpers/translate";

const BitcoinDominance = ({
  btcPercent = 59.3,
  ethPercent = 10.7,
  otherPercent = 29.9,
}) => {
  const { __ } = useTranslation();

  return (
    <div className="bitcoin-dominance">
      <h3 className="bitcoin-dominance__title">
        {__("markets.bitcoinDominanceTitle")}
      </h3>

      <div className="bitcoin-dominance__legend">
        <div className="bitcoin-dominance__legend-item">
          <span className="bitcoin-dominance__label">
            <span className="bitcoin-dominance__dot bitcoin-dominance__dot--btc" />
            Bitcoin
          </span>
          <span className="bitcoin-dominance__value">{btcPercent}%</span>
        </div>

        <div className="bitcoin-dominance__legend-item">
          <span className="bitcoin-dominance__label">
            <span className="bitcoin-dominance__dot bitcoin-dominance__dot--eth" />
            Ethereum
          </span>
          <span className="bitcoin-dominance__value">{ethPercent}%</span>
        </div>

        <div className="bitcoin-dominance__legend-item">
          <span className="bitcoin-dominance__label">
            <span className="bitcoin-dominance__dot bitcoin-dominance__dot--other" />
            {__("markets.bitcoinDominanceOther")}
          </span>
          <span className="bitcoin-dominance__value">{otherPercent}%</span>
        </div>
      </div>

      <div className="bitcoin-dominance__bar">
        <div
          className="bitcoin-dominance__bar-segment bitcoin-dominance__bar-segment--btc"
          style={{ width: `${btcPercent}%` }}
        />
        <div
          className="bitcoin-dominance__bar-segment bitcoin-dominance__bar-segment--eth"
          style={{ width: `${ethPercent}%` }}
        />
        <div
          className="bitcoin-dominance__bar-segment bitcoin-dominance__bar-segment--other"
          style={{ width: `${otherPercent}%` }}
        />
      </div>
    </div>
  );
};

export default BitcoinDominance;
